import { useState } from 'react'
import { Input } from 'reactstrap'
import { isDisabled } from '../../utils'

export default function AppObjectFieldNumber({ field, action, value, handleChange, hasChanged, inputAttribute }) {
  console.log(`AppObjectFieldNumber rendered: ${field.name}`, inputAttribute)

  const [text, setText] = useState(value)

  function handleTextChange(event) {
    console.log('onlywantthis', event)

    setText(event.target.value)
    handleChange(event, hasChanged)
  }

  if (isDisabled(action, field.behaviorType)) {
    return (<span>{text}</span>)
  }
  return (
    <Input
      data-cy={`field-${field.id}`}
      valid={inputAttribute === 'valid'}
      invalid={inputAttribute === 'invalid'}
      type="number"
      name={field.id}
      bsSize="sm"
      style={{ width: 'auto' }}
      id={field.id}
      value={text}
      onKeyDown={(e) => e.key === 'e' && e.preventDefault()}
      onChange={(event) => handleTextChange(event)}
      size={field.width ? field.width.toString() : null}
    />
  )
}
